<template>
  <div class="staffing">
    <el-table :data="tableData" style="width: 100%" class="w100 table">
      <el-table-column label="序号" type="index" width="60">
        <!-- <el-table-column prop="name" label="姓名"> </el-table-column> -->
      </el-table-column>
      <el-table-column label="类别">
        <el-table-column prop="name" label="离休人员"> </el-table-column>
      </el-table-column>
      <el-table-column label="应发" align="center">
        <el-table-column
          prop="postPay"
          label="职务岗位工资"
          show-overflow-tooltip
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="allowancePay"
          label="津贴奖金"
          show-overflow-tooltip
          width="80"
        >
        </el-table-column>
        <el-table-column
          prop="retireProportionPay"
          label="退休费计发比例"
          show-overflow-tooltip
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="afterConversionPay"
          label="折算后退休费"
          show-overflow-tooltip
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="retireLifePay"
          label="离退休生活补贴"
          show-overflow-tooltip
          width="120"
        >
        </el-table-column>
        <el-table-column prop="trafficPay" label="交通费" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="nursingPay" label="护理费" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="retireLifeAddPay"
          label="离退休后增加离退休费"
          show-overflow-tooltip
           width="140"
        >
        </el-table-column>
        <el-table-column prop="lifePay" label="生活补助" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="propertyPay" label="物业补贴" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="mustTotal" label="应发合计" show-overflow-tooltip>
        </el-table-column>
      </el-table-column>
      <el-table-column label="应扣" align="center">
        <el-table-column prop="waterPay" label="水费" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="electricPay" label="电费" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="healthPay" label="卫生费" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="deductTotal" label="扣款合计" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="actualPay" label="实发合计" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="payTime" label="发放日期" show-overflow-tooltip>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      default: [],
      require: true,
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="less" scoped>
/deep/.el-table {
  width: 100%;
  height: 100%;
  .el-table__body-wrapper {
    max-height: calc(100vh - 300px);
    overflow-y: auto;
  }
}
</style>